import { useNavigate } from 'react-router-dom';
import { useCurrentUser } from "../../../utils/CurrentUserContext";
import Spinner from "../../icons/Spinner";
import Table from "../Table/Table";
import { getCampaignsColumns } from "../../../utils/campaign-utils";
import { useCampaignsWithCost } from "../../../utils/api/cube";


const HomeList = ({campaigns, error, loading}: any) => {

  const {user} = useCurrentUser();
  const navigate = useNavigate();

  const campaignsWithCost = useCampaignsWithCost(campaigns)

  if (error)
  return <span>Error :(</span>;

  if (loading || !user)
  return <Spinner />;

  const handleRowClicked = (row: any) => {
    // Check if user is the campaign owner
    const isOwner = row.ownerCompanyId === user.company._id;

    // If user is the owner, go to details page, otherwise go to reporting
    if (isOwner) {
      navigate(`/campaigns/${row._id}/details`);
    } else {
      navigate(`/campaigns/${row._id}/report`);
    }
  };

  return (
    <Table
      columns={getCampaignsColumns(user.company, {status: false, owner: false})}
      data={campaignsWithCost}
      onRowClicked={handleRowClicked}
      searchable={false}
      pagination={false}
    />
  );
};

export default HomeList;
